export default "__VITE_ASSET__DSPFFIrp__"